module.exports = __webpack_public_path__ + "static/img/source2.72908ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/zh/source2.png
// module id = pFPB
// module chunks = 1